import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: пользователь изменил фильтр стоимости недвижимости в блоке ипотечных офферов.
 */
export function trackObjectCostFilterChange(): void {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Promo',
    label: 'object_cost',
    name: 'oldevent',
    products: [createDeveloperProduct()],
  });
}
